import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CoursesComponent} from './courses.component';
import {AddCourseComponent} from './add-course/add-course.component';

const routes: Routes = [
    {
        path: 'category',
        component: CoursesComponent,
        data: {animation: 'category'}
    },
    {
        path: 'category/add',
        component: AddCourseComponent,
        data: {animation: 'category/add'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CoursesRoutingModule {
}
